import React from 'react';
type SectionHeadingProps = {
  title: string;
  subtitle?: string;
};
export function SectionHeading({
  title,
  subtitle
}: SectionHeadingProps) {
  return <div className="text-center" data-id="element-52" data-mp="3tw9xmwne6kjm">
      <h2 className="mx-auto max-w-4xl font-display text-3xl font-black uppercase leading-tight text-cream md:text-5xl" data-id="element-53" data-mp="3f1luvq9dm07p">{title}</h2>
      <div className="mx-auto mt-6 h-0.5 w-16 bg-gold" aria-hidden="true" data-id="element-54" data-mp="3k0yhqb08z7aa" />
      {subtitle && <p className="mx-auto mt-6 max-w-3xl text-xl font-medium leading-snug text-neutral-300 md:text-2xl" data-id="element-55" data-mp="blesdn2p690i">{subtitle}</p>}
    </div>;
}